










import Vue from 'vue';

export default Vue.extend({
  name: "MorningStarMain2d",
  data: () => {
    return {};
  },
});
